module.exports = __webpack_public_path__ + "img/page-active-title.81511cea.png";